var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Entrant details/Icon/Property 24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.976311 10.3096C1.60143 9.68444 2.44928 9.33325 3.33333 9.33325H8C8.88406 9.33325 9.7319 9.68444 10.357 10.3096C10.9821 10.9347 11.3333 11.7825 11.3333 12.6666V13.9999C11.3333 14.3681 11.0349 14.6666 10.6667 14.6666C10.2985 14.6666 10 14.3681 10 13.9999V12.6666C10 12.1362 9.78929 11.6274 9.41421 11.2524C9.03914 10.8773 8.53043 10.6666 8 10.6666H3.33333C2.8029 10.6666 2.29419 10.8773 1.91912 11.2524C1.54405 11.6274 1.33333 12.1362 1.33333 12.6666V13.9999C1.33333 14.3681 1.03486 14.6666 0.666667 14.6666C0.298477 14.6666 0 14.3681 0 13.9999V12.6666C0 11.7825 0.35119 10.9347 0.976311 10.3096Z",
    fill: "#16192C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66634 2.66659C4.56177 2.66659 3.66634 3.56202 3.66634 4.66658C3.66634 5.77115 4.56177 6.66658 5.66634 6.66658C6.77091 6.66658 7.66634 5.77115 7.66634 4.66658C7.66634 3.56202 6.77091 2.66659 5.66634 2.66659ZM2.33301 4.66658C2.33301 2.82564 3.82539 1.33325 5.66634 1.33325C7.50729 1.33325 8.99967 2.82564 8.99967 4.66658C8.99967 6.50753 7.50729 7.99992 5.66634 7.99992C3.82539 7.99992 2.33301 6.50753 2.33301 4.66658Z",
    fill: "#16192C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3337 4.66675C13.7018 4.66675 14.0003 4.96522 14.0003 5.33341V9.33342C14.0003 9.7016 13.7018 10.0001 13.3337 10.0001C12.9655 10.0001 12.667 9.7016 12.667 9.33342V5.33341C12.667 4.96522 12.9655 4.66675 13.3337 4.66675Z",
    fill: "#16192C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.667 7.33341C10.667 6.96522 10.9655 6.66675 11.3337 6.66675H15.3337C15.7018 6.66675 16.0003 6.96522 16.0003 7.33341C16.0003 7.7016 15.7018 8.00008 15.3337 8.00008H11.3337C10.9655 8.00008 10.667 7.7016 10.667 7.33341Z",
    fill: "#16192C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.c0becfe842329c15f71185ccfd106d4a.svg";
export { ForwardRef as ReactComponent };